export default __webpack_public_path__ + "static/media/forgot-password-v2-dark.5349f5b0.svg";